//Style
import '../scss/style.scss';
import 'slick-carousel/slick/slick.scss';

//Javascript
import jQuery from "jquery";
import ASScroll from '@ashthornton/asscroll'
import { VanillaTilt } from "./tilt";
import { gsap } from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import slick from "slick-carousel/slick/slick";
import { SplitText } from  "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger);



// https://github.com/ashthornton/asscroll
    const asscroll = new ASScroll({
        customScrollbar: true
    });




    if (window.matchMedia("(min-width: 992px)").matches) {

        ScrollTrigger.defaults({
            scroller: '.inner'
        });

        ScrollTrigger.scrollerProxy(".inner", {
            scrollTop(value) {
                return arguments.length ? asscroll.scrollTo(value) : -asscroll.smoothScrollPos;
            },
            getBoundingClientRect() {
                return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight}
            }
        });

    } else {


    }



    asscroll.on("raf", ScrollTrigger.update);
    ScrollTrigger.addEventListener("refresh", () => asscroll.onResize());


window.addEventListener("load", () => {


    jQuery('body').addClass('load');



    if (window.matchMedia("(min-width: 992px)").matches) {
        VanillaTilt.init(document.querySelectorAll(".tilt-transition"));
    }

    jQuery('a').click(function () {
        if (jQuery(this).attr('href') != 'javascript:void(0);') {
            jQuery('body').removeClass('load');
        }
    });


    jQuery('.has-sub-menu').click(function () {

        var targ = jQuery(this).parent().find('.sub-menu');
        var tl = new gsap.timeline();
        tl.to(targ, {height: "auto", duration: 1})
        tl.to(targ, {opacity: 1, duration: .5})

    });

    jQuery('.menu-btn').click(function () {

        if (jQuery(this).hasClass('on')) {
            jQuery(this).removeClass('on');
            jQuery('.sitemenu--mobile').removeClass('active');
            jQuery('.menu-btn__wrap').removeClass('menu-open');
        } else {
            jQuery(this).addClass('on');
            jQuery('.sitemenu--mobile').addClass('active');
            jQuery('.menu-btn__wrap').addClass('menu-open');
        }

    });

    let splitted = new SplitText(".splitText", {type: "chars"});

    const totalScroll =
        document.querySelector(".asscroll-container").scrollHeight -
        innerHeight;




    let viewportChecks = gsap.utils.toArray('.checkViewport');
    viewportChecks.forEach((vc) => {

        ScrollTrigger.create({
            trigger: vc,
            start: 'center bottom',
            end: 'bottom top',
            scrub: true,
            onEnter: () => {
                jQuery(vc).addClass('in-view');
            }
        });

    });

    let viewportChecksCenter = gsap.utils.toArray('.checkViewportCenter');
    viewportChecksCenter.forEach((vcc) => {


        ScrollTrigger.create({
            trigger: vcc,
            start: 'center bottom',
            end: 'bottom top',
            scrub: true,
            onEnter: () => {
                jQuery(vcc).addClass('in-view');
            }
        });


    });

    if (window.matchMedia("(min-width: 992px)").matches) {
        ScrollTrigger.create({
            trigger: ".top",
            endTrigger: ".footer",
            start: "top top",
            end: "bottom bottom",
            pin: ".sitemenu"
        });
    }

    if (window.matchMedia("(min-width: 992px)").matches) {
        ScrollTrigger.create({
            trigger: ".top",
            endTrigger: ".footer",
            start: "top top",
            end: "bottom bottom",
            pin: ".top__bg"
        });
    }





    jQuery(".parallax-el").each(function () {
        gsap.to(jQuery(this), {
            scrollTrigger: {
                scrub: true,
                trigger: jQuery(this).closest('.parallax-el-wrap'),
                start: 'top bottom',
            },
            y: (i, target) => -totalScroll * target.dataset.speed,
            ease: "none"
        });
    });


    asscroll.enable(false, true, document.querySelector(".inner"));


});


//SCROLL MOBILE
if (window.matchMedia("(max-width: 991.99px)").matches) {
    var previousScroll = 0;

    jQuery(window).scroll(function (e) {

        var currentScroll = jQuery(this).scrollTop();

        if (window.scrollY > 100 && currentScroll > previousScroll) {
            jQuery('.menu-btn__wrap').addClass('hide');
        } else {
            jQuery('.menu-btn__wrap').removeClass('hide');
        }

        if (window.scrollY > 100) {
            jQuery('.menu-btn__wrap').addClass('sticky');
        } else {
            jQuery('.menu-btn__wrap').removeClass('sticky');
        }

        previousScroll = currentScroll;

    });
}






